import styled from "styled-components";
import { COLORS, FONT_WEIGHT } from "../../theme";

export type ButtonProps = React.HTMLProps<HTMLButtonElement> & {
  title?: string;
  width?: string;
  secondary?: boolean;
  isLoading?: boolean;
};

export const Content = styled.button<ButtonProps>`
  all: unset;
  background-color: ${({ secondary }) =>
    !secondary ? COLORS.WHITE : COLORS.BLUE};
  color: ${({ secondary }) => (!secondary ? COLORS.BLACK : COLORS.WHITE)};
  width: ${({ width }) => width ?? "180px"};
  text-align: center;
  font-size: 18px;
  font-weight: ${FONT_WEIGHT.BOLD};
  padding: 16px 0;
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  transition: 0.3s all;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ disabled }) => (!disabled ? 1 : 0.7)};

  @media (max-width: 1420px) {
    padding: 12px 0;
  }

  &:hover {
    transition: 0.3s all;
    box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.25);
  }
`;

export const Spinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0 !important;
  margin-right: 8px;

  &::after {
    content: "";
    width: 20px;
    height: 20px;
    border: 4px solid ${COLORS.BLUE};
    border-top-color: ${COLORS.WHITE};
    border-radius: 50%;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    to {
      transform: rotate(1turn);
    }
  }
`;
